/**
 * @generated SignedSource<<fa17ee758c88a411348c33ab37d8a7ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartContentNodeInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation$variables = {
  input: StartContentNodeInput;
};
export type NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation$data = {
  readonly LearnV2: {
    readonly startContentNode: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation = {
  response: NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation$data;
  variables: NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StartContentNodePayload",
        "kind": "LinkedField",
        "name": "startContentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5f43482d5fd3c3e94f0a394c62ff8395",
    "id": null,
    "metadata": {},
    "name": "NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation",
    "operationKind": "mutation",
    "text": "mutation NavigateDirectToQuestionsAdvanceContentButton_StartContentNodeMutation(\n  $input: StartContentNodeInput!\n) {\n  LearnV2 {\n    startContentNode(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "406f4ba53391abbd9c448a98f2996e60";

export default node;
